// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-btn-primary {
  border-radius: 0.188rem;
  font-weight: bold;
  letter-spacing: 0.125rem;
}

.ant-collapse-borderless {
  background-color: transparent;
}
.ant-collapse-borderless > .ant-collapse-item {
  border: none;
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header {
  font-size: 1.063rem;
  padding: 0.75rem 0;
}
.ant-checkbox-wrapper {
  padding: 0.313rem 0;
}
.ant-divider-vertical {
  height: auto;
  /* border-left: 0.125rem solid rgba(0, 0, 0, 0.06); */
  border-left: 0.063rem solid rgba(138, 27, 106, 0.5);
}

.ant-pagination-total-text {
  display: flex;
  margin-right: auto;
}

.offline-pagination {
  margin-top: 1.875rem;
  display: flex;
  justify-content: center;
}

.ant-notification-notice-error {
  background-color: red !important;
}
.ant-notification-notice-description {
  color: white;
}
.ant-notification-notice {
  background-color: var(--primary-color);
}
.ant-notification-notice-with-icon .ant-notification-notice-message,
.anticon.ant-notification-notice-icon-error,
.ant-notification-close-icon {
  color: white;
}

.ant-progress-bg.ant-progress-bg {
  background-color: var(--primary-color);
}
@media only screen and (max-width: 820px) {
  .ant-btn-primary {
    letter-spacing: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/_antd.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,qDAAqD;EACrD,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,YAAY;AACd;AACA;EACE,sCAAsC;AACxC;AACA;;;EAGE,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;AACA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".ant-btn-primary {\r\n  border-radius: 0.188rem;\r\n  font-weight: bold;\r\n  letter-spacing: 0.125rem;\r\n}\r\n\r\n.ant-collapse-borderless {\r\n  background-color: transparent;\r\n}\r\n.ant-collapse-borderless > .ant-collapse-item {\r\n  border: none;\r\n}\r\n.ant-collapse > .ant-collapse-item > .ant-collapse-header {\r\n  font-size: 1.063rem;\r\n  padding: 0.75rem 0;\r\n}\r\n.ant-checkbox-wrapper {\r\n  padding: 0.313rem 0;\r\n}\r\n.ant-divider-vertical {\r\n  height: auto;\r\n  /* border-left: 0.125rem solid rgba(0, 0, 0, 0.06); */\r\n  border-left: 0.063rem solid rgba(138, 27, 106, 0.5);\r\n}\r\n\r\n.ant-pagination-total-text {\r\n  display: flex;\r\n  margin-right: auto;\r\n}\r\n\r\n.offline-pagination {\r\n  margin-top: 1.875rem;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.ant-notification-notice-error {\r\n  background-color: red !important;\r\n}\r\n.ant-notification-notice-description {\r\n  color: white;\r\n}\r\n.ant-notification-notice {\r\n  background-color: var(--primary-color);\r\n}\r\n.ant-notification-notice-with-icon .ant-notification-notice-message,\r\n.anticon.ant-notification-notice-icon-error,\r\n.ant-notification-close-icon {\r\n  color: white;\r\n}\r\n\r\n.ant-progress-bg.ant-progress-bg {\r\n  background-color: var(--primary-color);\r\n}\r\n@media only screen and (max-width: 820px) {\r\n  .ant-btn-primary {\r\n    letter-spacing: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
